import React from 'react';

const AISuggestCont = (props) => {
    return (
        <div onClick={props?.onClick} style={{ cursor: 'pointer', padding: '6px 8px', borderRadius: 8, border: '1px solid #0358A7', background: '#FFFFFF' }}>
            {props?.text}
        </div>
    );
}

export default AISuggestCont;